import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import LogView from 'components/History/LogView';
import { useParams } from 'react-router-dom';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle';
import makeStyles from '@material-ui/styles/makeStyles';

import GeneralInfo from './GeneralInfo/GeneralInfo';

const useStyles = makeStyles({
  ...extendedFormsStyle,
  ...buttonsStyle,
});
const UserForm = () => {
  const { id } = useParams();
  const classes = useStyles();
  return (
    <>
      <GeneralInfo classes={classes} />
      <LogView iri={`/employees/${id}`} />
    </>
  );
};

export default UserForm;
